<template>
    <form-view class="weibo-service-detail-view">
        <template slot="field" v-if="store.serviceDetail">
            <veui-field label="应用名称：">
                <veui-span>{{store.serviceDetail.appName}}</veui-span>
            </veui-field>
            <veui-field label="服务名称：">
                <veui-span>{{store.serviceDetail.name}}</veui-span>
            </veui-field>
            <veui-field label="authKey：">
                <veui-span>{{ authKey }}</veui-span>
            </veui-field>
            <veui-field label="activityId：">
                <veui-span>{{ activityId || weiboId }}</veui-span>
            </veui-field>
            <veui-field label="微博ID：">
                <veui-span>{{ weiboId }}</veui-span>
            </veui-field>
            <veui-field label="微博名称：">
                <veui-span>{{ weiboName }}</veui-span>
            </veui-field>
        </template>
        <template slot="operation">
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import DetailModel from './DetailModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Span} from 'veui';
import serviceMixin from '@/common/mixins/service';
import {get} from 'lodash';

export default createView(FormView, DetailModel, {
    name: 'WeiboServiceDetailView',
    components: {
        'veui-field': Field,
        'veui-span': Span,
        'veui-button': Button
    },
    mixins: [serviceMixin],
    computed: {
        weiboId() {
            return get(this.store.serviceDetail, 'serviceData.weiboId');
        },
        weiboName() {
            return get(this.store.serviceDetail, 'serviceData.weiboName');
        }
    }
});
</script>
